/* src/app/modules/shared/components/header-column/header-column-quantity-and-size/header-column-quantity-and-size.component.scss */
app-header-column-quantity-and-size {
  display: contents;
}
/*# sourceMappingURL=header-column-quantity-and-size.component.css.map */
